<template>
  <a-card class="m-display-flex flex-column nowrap">
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Bank Account">
            <a-select
              placeholder="Select Bank Account"
              allowClear
              showSearch
              @change="handleBank"
              v-decorator="[
                'bank_account',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? detil_account[0].bank_account
                    : '',
                },
              ]"
            >
              <a-select-option v-for="item in combo_bank" :key="item.value">{{
                item.text
              }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="Project Currency">
            <a-select
              placeholder="Select Project Currency"
              allowClear
              showSearch
              v-decorator="[
                'project_currency',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? detil_account[0].project_currency
                    : '',
                },
              ]"
              disabled
            >
              <a-select-option
                v-for="item in combo_currency"
                :key="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item label="Exchange rate 1.00 USD to IDR">
            <a-input-number
              v-decorator="[
                'exchange_rate',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? detil_account[0].exchange_rate
                    : '',
                },
              ]"
              type="number"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
          <a-form-item label="Project Value">
            <a-input-number
              v-decorator="[
                'project_value',
                {
                  rules: [{ required: true, validator: validatePass }],
                  initialValue: detil_account
                    ? detil_account[0].project_value
                    : '',
                },
              ]"
              disabled
              type="number"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <!-- <a-form-item label="Value AR">
            <a-input-number
              v-decorator="[
                'value_ar',
                {
                  rules: [{ required: true, validator: validatePass }],
                  initialValue: detil_account ? detil_account[0].value_ar : '',
                },
              ]"
              type="number"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>

          <a-form-item label="Termin Description">
            <a-input
              v-decorator="[
                'work_name',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account ? detil_account[0].work_name : '',
                },
              ]"
            ></a-input>
          </a-form-item> -->

          <!-- <a-form-item label="Termin Release">
            <a-input
              v-decorator="[
                'termin_release',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account ? detil_account[0].termin_release : '',
                },
              ]"
              disabled
            ></a-input>
          </a-form-item> -->

          <a-form-item label="PPN">
            <a-radio-group
              buttonStyle="solid"
              v-decorator="[
                'ppn',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account ? detil_account[0].ppn : '',
                },
              ]"
              ref="ppn"
            >
              <a-radio-button value="1" ref="include">Include</a-radio-button>
              <a-radio-button value="0" ref="Exclude">Exclude</a-radio-button>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="Invoice Date">
            <a-date-picker
              placeholder="Select Date"
              :format="getDefaultDateFormat"
              v-decorator="[
                'invoice_date',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? moment(detil_account[0].invoice_date)
                    : moment(),
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="E-faktur no">
            <a-input
              v-decorator="[
                'efaktur_no',
                {
                  rules: [{ required: true }],
                  initialValue: detil_account
                    ? detil_account[0].efaktur_no
                    : '',
                },
              ]"
            ></a-input>
          </a-form-item>

          <a-form-item label="Upload File Support">
            <a-upload
              :showUploadList="true"
              :file-list="push"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              v-decorator="[
                'upload',
                {
                  rules: [{ required: true, validator: validateStatusUpload }],
                  valuePropName: 'push',
                },
              ]"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button class="padding-remove" type="primary" @click="save"
            >save</a-button
          >
          <a-button type="primary" @click="preview"
            >Preview Account Receiveable</a-button
          >
      </div>
    </template> -->
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";

export default {
  name: "detilAccount",
  props: {
    id: String,
    detil_account: {},
    combo_bank: {},
    combo_currency: {},
  },
  mixins: [CurrencyFormat],
  components: {},
  data() {
    return {
      postData: new FormData(),
      push: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate", "getDefaultDateFormat"]),
  },
  created() {
    if (this.detil_account) {
      this.fetch(this.detil_account[0]);
    }
  },
  methods: {
    moment,
    fetch(item) {
      let typefile = item.upload_document_support.substr(item.upload_document_support.lastIndexOf("."));
      //console.log(typefile)
      if (typefile == ".xls"){
        typefile = "data:application/vnd.ms-excel;base64,";
      } else if(typefile == ".xlsx"){
        typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      } else if(typefile == ".doc"){
        typefile = "data:application/msword;base64,";
      } else if(typefile == ".docx"){
        typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      } else if(typefile == ".pdf"){
        typefile = "data:application/pdf;base64,";
      } else if(typefile == ".jpeg" || typefile == ".jpg"){
        typefile = "data:image/jpeg;base64,";
      } else if(typefile == ".png"){
        typefile = "data:image/png;base64,";
      }

      var file = this.dataURLtoFile(
        typefile + item.files,
        item.upload_document_support
      );
      file.uid = "vc-upload-1-1";
      file.status = "done";
      file.exist = true;
      file.url = this.$serviceUrl + item.path;
      this.push.push(file);
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    validateStatusUpload(rule, value, callback) {
      if (this.push.length > 0) {
        callback();
        return;
      }
      callback("File upload can't be empty!");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let ext = file.name.substr(file.name.lastIndexOf("."));
      let extension = ext == ".xls" || ext == ".xlsx"
                      || ext == ".pdf" || ext == ".jpg"
                      || ext == ".jpeg" || ext == ".png";
      if (extension) {
        if (FileSize > 10) {
          this.displayMessage("large-file-10mb");
        } else {
          this.push = [file];
          //this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessageValue("error-other", "file type only xls, xlsx, pdf, jpg, jpeg, png!");
      }
    },
    handleRemove() {
      this.push = [];
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        
        let data = {
          bank_account: values.bank_account,
          efaktur_no: values.efaktur_no,
          exchange_rate: values.exchange_rate,
          invoice_date: this.moment(values.invoice_date),
          ppn: values.ppn,
          project_currency: values.project_currency,
          project_value: values.project_value,
          value_ar: values.value_ar,
          work_name: values.work_name,
          revision_no: this.detil_account[0].revision_no,
        };
        
        if (this.push[0].exist){
          data.upload_document_support= this.push[0].name;
        }

        Event.$emit("emitChild", {
          detil_account: data,
          new_upload: !this.push[0].exist ? this.push : [],
        });
      });
    },
    validatePass(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("the value must be rather than 0!");
    },
    handleBank(item) {
      const bank = _.filter(this.combo_bank, data => data.value == item);
      this.detil_account[0].project_currency = bank[0].currency
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style></style>
